import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmConfigurationRoute: InvariantJiraRoute = {
	name: 'products-jsm-configuration',
	path: '/jira/settings/products/jira-service-management-configuration',
	exact: true,
};
